
import PortWindDashboard$002Emodule from "../../../src/StenaWeather.WeatherServiceUI.Client/Pages/Portwind/PortWindDashboard.module.scss";
import { cons, collect, choose, chunkBySize, exists, filter, ofArray, forAll, singleton as singleton_1, empty, tryFind, map } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { createElement, useContext, useEffect, useMemo, useState } from "react";
import React from "react";
import { debounce } from "../../Utils.js";
import { Impl_createRemoveOptions, Impl_adjustPassive } from "../../Listeners.js";
import { timeZoneContext } from "../../Components/TimeZones/Context.js";
import { Msg, update as update_1, init as init_1 } from "./PortWindDashboardState.js";
import { UseElmishHelper_programWithCustomErrorHandler, React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.5.0.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { compare, safeHash, createObj, equals } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { orElse, toArray, map2, defaultArg, map as map_1, unwrap, bind } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { Style_dashboardRoot, quayWeatherValue, boxFromDefinition, Style_sensorLabel, Style_weatherBoxContainer, Style_directionIcon, clearAllButton as clearAllButton_1, clickableIcon, expandForGroupSensor as expandForGroupSensor_1, getSensorName as getSensorName_1 } from "./PortWindDashboardHelpers.js";
import { utcNow, op_Subtraction } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { min, max } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { faRotateRight, faCog, faThList, faChartLine, faMapMarkedAlt, faTh } from "@fortawesome/free-solid-svg-icons";
import { ViewHelpers_fallbackDataBanner, WeatherValue_WeatherBox, WeatherValue_values, ViewHelpers_spanWith, ViewHelpers_mkRowWith, ViewHelpers_mkColumnWith, MapCenterAndZoom, WeatherValue_valuesNotEmpty, ReportGraphView, ViewHelpers_spaceN, ViewHelpers_mkText, ViewHelpers_mkRow, ViewHelpers_leftRightColumns, ViewHelpers_divWith, MainView } from "./PortWindCommon.js";
import { isEmpty, choose as choose_1, tryHead, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { PageTitle_titleWith } from "../../SharedView.js";
import { Color, theme } from "../../Theme.js";
import { WeatherBox_rotatingDirectionSvg, WeatherBox_trendChart, WeatherBox_mapBoxMaximizeIcon, WeatherBox_contentSublabel, WeatherBox_mapBox, WeatherBox_weatherValue, WeatherBox_content, CheckboxControls_sensorCheckboxes, CheckboxControls_chartsValuesAndCheckboxes, Header_lastUpdatedView, Header_unitSelectionSwitch, Header_trendTimeWindowDropdown, Header_dateRangePicker, Header_sensorSelectionDropdown } from "./PortWindDashboardViews.js";
import { csvExportSection } from "./PortWindExport.js";
import { contains } from "../../fable_modules/fable-library-js.5.0.0/Set.js";
import { trendCharts } from "./PortWindChart.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { PortWindTableView } from "./PortWindTable.js";
import { AllSensorsMapView } from "./PortWindMap.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { tryFind as tryFind_1, toList as toList_1, ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { PortWindWeather_Default, PortWindWeatherModule_mergeLatest } from "../../StenaWeather.Domain/PortWind.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0/Seq2.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { defaultOf as defaultOf_2 } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { thresholdModalView } from "./PortWindThresholdModal.js";

export const cn = (() => {
    const styles = PortWindDashboard$002Emodule;
    const cnFn = (name) => (styles[name]);
    const cnFns = (names) => map((x) => (styles[x]), names);
    return {
        className: cnFn,
        classes: cnFns,
        prop: {
            className: (arg) => ["className", cnFn(arg)],
            classes: (arg_1) => ["className", join(" ", cnFns(arg_1))],
        },
    };
})();

export function PortWindDashboardView($props) {
    let Width;
    const page = $props.page;
    const clientSessionId = $props.clientSessionId;
    const sensorReportChangeToMainView = $props.sensorReportChangeToMainView;
    const dateRange = $props.dateRange;
    const sensorId = $props.sensorId;
    const reservedWidth = $props.reservedWidth;
    const viewConfig = $props.viewConfig;
    const initStateChange = $props.initStateChange;
    const patternInput = useState((Width = window.innerWidth, {
        Height: window.innerHeight,
        Width: Width,
    }));
    const viewPort = patternInput[0];
    const action_1 = (_arg) => {
        debounce()(200)(() => {
            let Width_1;
            patternInput[1]((Width_1 = window.innerWidth, {
                Height: window.innerHeight,
                Width: Width_1,
            }));
        })();
    };
    const options_1 = undefined;
    const addOptions = useMemo(() => Impl_adjustPassive(options_1), [options_1]);
    const removeOptions = useMemo(() => Impl_createRemoveOptions(options_1), [options_1]);
    const fn = useMemo(() => ((arg) => {
        action_1(arg);
    }), [action_1]);
    useEffect(() => {
        const setup = (() => {
        if (addOptions == null) {
            window.addEventListener("resize", fn);
        }
        else {
            const options_1_1 = addOptions;
            window.addEventListener("resize", fn, options_1_1);
        }
        return () => {
            if (removeOptions == null) {
                window.removeEventListener("resize", fn);
            }
            else {
                const options_2 = removeOptions;
                window.removeEventListener("resize", fn, options_2);
            }
        };
    })();
        return setup;
        }, undefined);;
    const ctx = useContext(timeZoneContext);
    let patternInput_1;
    const init = init_1(initStateChange, viewConfig, sensorId, dateRange, clientSessionId);
    patternInput_1 = React_useElmish_Z6C327F2E(() => UseElmishHelper_programWithCustomErrorHandler(undefined, ProgramModule_mkProgram(() => init, (msg, state) => update_1(page, sensorReportChangeToMainView, msg, state), (_arg_1, _arg_1_1) => {
    })), undefined, [viewConfig]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffect(() => {
        let matchResult, id_1;
        if (sensorId != null) {
            if (!equals(state_1.SelectedSensor, sensorId)) {
                matchResult = 0;
                id_1 = sensorId;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                dispatch(new Msg(2, [id_1]));
                break;
            }
            case 1: {
                break;
            }
        }
    }, [sensorId]);
    const patternInput_2 = useState(false);
    const setThresholdModalOpen = patternInput_2[1];
    const weather = state_1.Weather;
    const sensor = bind((sId) => tryFind((x) => equals(x.SensorId, sId), state_1.Sensors), state_1.SelectedSensor);
    const getSensorName = (sensorId_1) => getSensorName_1(state_1.Sensors, sensorId_1);
    const expandForGroupSensor = (defs) => expandForGroupSensor_1(sensor, state_1.HiddenSensors, getSensorName, defs);
    let isStale;
    const matchValue = viewConfig.StaleDataThreshold;
    let matchResult_1, lastUpdated, threshold;
    if (matchValue != null) {
        if (weather != null) {
            matchResult_1 = 0;
            lastUpdated = weather.LastUpdated;
            threshold = matchValue;
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            isStale = (op_Subtraction(utcNow(), lastUpdated) > threshold);
            break;
        }
        default:
            isStale = false;
    }
    let patternInput_3;
    const baseWidth = viewPort.Width - reservedWidth;
    const baseWidthPercent = (baseWidth / viewPort.Width) * 100;
    const columns = max(1, min(3, ~~(baseWidth / 333))) | 0;
    patternInput_3 = [columns, (baseWidthPercent / columns) - (columns * 1)];
    const columns_1 = patternInput_3[0] | 0;
    const columnWidth_1 = patternInput_3[1];
    const header = (config, lastUpdated_1) => {
        const config_1 = config(state_1.MainView);
        const switchViewIcon = (ev, switchIcon, switchView) => clickableIcon(5 + "vmin", empty(), (_arg_2) => {
            dispatch(ev(switchView));
        }, switchIcon);
        const switchMainViewIcon = (toView, toIcon) => {
            let patternInput_4;
            const matchValue_2 = state_1.MainView;
            let matchResult_2;
            switch (matchValue_2.tag) {
                case 3: {
                    if (toView.tag === 3) {
                        matchResult_2 = 0;
                    }
                    else {
                        matchResult_2 = 2;
                    }
                    break;
                }
                case 1: {
                    if (toView.tag === 1) {
                        matchResult_2 = 1;
                    }
                    else {
                        matchResult_2 = 2;
                    }
                    break;
                }
                default:
                    matchResult_2 = 2;
            }
            switch (matchResult_2) {
                case 0: {
                    patternInput_4 = [faTh, new MainView(0, [])];
                    break;
                }
                case 1: {
                    patternInput_4 = [faTh, new MainView(0, [])];
                    break;
                }
                default:
                    patternInput_4 = [toIcon, toView];
            }
            return switchViewIcon((Item) => (new Msg(7, [Item])), patternInput_4[0], patternInput_4[1]);
        };
        return ViewHelpers_divWith([], singleton_1(ViewHelpers_leftRightColumns(columns_1 <= 2, ((columns_1 * columnWidth_1) + (((columns_1 - 1) * 2) * 0.5)) + "vw", singleton_1(ViewHelpers_mkRow(toList(delay(() => {
            let color;
            return append(config_1.ShowTitle ? singleton(PageTitle_titleWith((color = theme(new Color(0, [])), (s) => ViewHelpers_mkText(color, 4, [], s)), viewConfig.Title, "")) : empty_1(), delay(() => append(config_1.SensorSelection ? append(ViewHelpers_spaceN(2), delay(() => singleton(Header_sensorSelectionDropdown(state_1.Sensors, state_1.SelectedSensor, dispatch)))) : empty_1(), delay(() => append(config_1.MainViewsEnabled(new MainView(3, [undefined])) ? append(ViewHelpers_spaceN(2), delay(() => singleton(switchMainViewIcon(new MainView(3, [undefined]), faMapMarkedAlt)))) : empty_1(), delay(() => append(config_1.MainViewsEnabled(new MainView(1, [])) ? append(ViewHelpers_spaceN(2), delay(() => singleton(switchMainViewIcon(new MainView(1, []), faChartLine)))) : empty_1(), delay(() => append(config_1.TimeRangePicker ? append(ViewHelpers_spaceN(2), delay(() => {
                let patternInput_5, matchValue_4;
                return append(singleton((patternInput_5 = ((matchValue_4 = state_1.MainView, (matchValue_4.tag === 2) ? ((matchValue_4.fields[0].tag === 1) ? [faChartLine, new ReportGraphView(0, [])] : [faThList, new ReportGraphView(1, [])]) : [faChartLine, new ReportGraphView(0, [])])), switchViewIcon((Item_1) => (new Msg(8, [Item_1])), patternInput_5[0], patternInput_5[1]))), delay(() => append(ViewHelpers_spaceN(2), delay(() => append(singleton(Header_dateRangePicker(state_1.DateTimeRange, dispatch)), delay(() => append((state_1.MainView.tag === 2) ? append(ViewHelpers_spaceN(2), delay(() => singleton(createElement(csvExportSection, {
                    state: state_1,
                    ctx: ctx,
                    expandForGroupSensor: expandForGroupSensor,
                })))) : (empty_1()), delay(() => ViewHelpers_spaceN(2)))))))));
            })) : empty_1(), delay(() => ((config_1.TimeRangeDropDown && equals(state_1.MainView, new MainView(1, []))) ? append(ViewHelpers_spaceN(2), delay(() => append(singleton(Header_trendTimeWindowDropdown(dispatch)), delay(() => ViewHelpers_spaceN(2))))) : empty_1())))))))))));
        })))), singleton_1(ViewHelpers_mkRow(toList(delay(() => append(config_1.UnitSelection ? singleton(Header_unitSelectionSwitch(state_1.UnitsIsMetric, dispatch)) : empty_1(), delay(() => append(equals(state_1.MainView, new MainView(1, [])) ? append(ViewHelpers_spaceN(2), delay(() => singleton(clickableIcon(4 + "vmin", empty(), (_arg_3) => {
            setThresholdModalOpen(true);
        }, faCog)))) : empty_1(), delay(() => append(config_1.Refresh ? append(ViewHelpers_spaceN(2), delay(() => singleton(clickableIcon(4 + "vmin", toList(delay(() => (state_1.IsRefreshing ? singleton(["className", cn.className("rotate")]) : empty_1()))), (_arg_4) => {
            dispatch(new Msg(4, [state_1.PollGeneration]));
        }, faRotateRight)))) : empty_1(), delay(() => (config_1.LastUpdated ? append(ViewHelpers_spaceN(2), delay(() => singleton(Header_lastUpdatedView(isStale, sensor, lastUpdated_1)))) : empty_1()))))))))))))));
    };
    const content = (w_4) => {
        const valuesNotEmpty = WeatherValue_valuesNotEmpty(state_1);
        const allWeatherValuesHidden = forAll((d_3) => contains(d_3.Id, state_1.HiddenWeatherValues), valuesNotEmpty);
        const chartsValuesAndCheckboxes = () => CheckboxControls_chartsValuesAndCheckboxes(dispatch, valuesNotEmpty, state_1.HiddenWeatherValues, expandForGroupSensor);
        const sensorCheckboxes = CheckboxControls_sensorCheckboxes(dispatch, sensor, state_1.HiddenSensors, getSensorName);
        const weatherValueCheckboxHeader = (checkboxes) => toList(delay(() => append(ViewHelpers_spaceN(2), delay(() => append(sensorCheckboxes, delay(() => append(singleton(ViewHelpers_mkRow(ofArray([clearAllButton_1(dispatch, allWeatherValuesHidden, new Msg(12, []), new Msg(11, [])), ViewHelpers_mkRow(checkboxes)]))), delay(() => ViewHelpers_spaceN(2)))))))));
        const matchValue_8 = state_1.MainView;
        switch (matchValue_8.tag) {
            case 1: {
                const patternInput_6 = chartsValuesAndCheckboxes();
                const children = toList(delay(() => append(weatherValueCheckboxHeader(patternInput_6[1]), delay(() => singleton(createElement(trendCharts, {
                    ctx: ctx,
                    viewPort: viewPort,
                    multipleChartsValues: singleton_1(patternInput_6[0]),
                    state: state_1,
                }))))));
                return createElement("div", defaultOf(), ...children);
            }
            case 2: {
                const children_6 = toList(delay(() => {
                    const patternInput_7 = chartsValuesAndCheckboxes();
                    const chartsValues = filter((values) => exists((d_4) => exists((w_5) => (d_4.GetValue(state_1, w_5) != null), state_1.WeatherHistory), values), map(singleton_1, patternInput_7[0]));
                    return append(weatherValueCheckboxHeader(patternInput_7[1]), delay(() => {
                        let children_3;
                        return singleton((children_3 = toList(delay(() => append(ViewHelpers_spaceN(2), delay(() => ((matchValue_8.fields[0].tag === 1) ? singleton(createElement(PortWindTableView, {
                            multipleChartsValues: chartsValues,
                            state: state_1,
                        })) : singleton(createElement(trendCharts, {
                            ctx: ctx,
                            viewPort: viewPort,
                            multipleChartsValues: chartsValues,
                            state: state_1,
                        }))))))), createElement("div", defaultOf(), ...children_3)));
                    }));
                }));
                return createElement("div", defaultOf(), ...children_6);
            }
            case 3: {
                const children_9 = toList(delay(() => append(ViewHelpers_spaceN(2), delay(() => singleton(createElement(AllSensorsMapView, {
                    state: state_1,
                    centerAndZoom: unwrap(matchValue_8.fields[0]),
                    onSensorSelected: (sId_1) => {
                        dispatch(new Msg(2, [sId_1]));
                        dispatch(new Msg(7, [new MainView(0, [])]));
                    },
                }))))));
                return createElement("div", defaultOf(), ...children_9);
            }
            default: {
                const w = w_4;
                const x_9 = map((arg_1) => ViewHelpers_mkRow(map((tupledArg_3) => {
                    const weatherPoint = tupledArg_3[1];
                    let innerContent;
                    const iconMargin = singleton_1(["marginRight", 3 + "vw"]);
                    innerContent = ((_arg_5) => {
                        switch (_arg_5.tag) {
                            case 1: {
                                const v_1 = _arg_5.fields[0];
                                return WeatherBox_content(empty(), v_1.Label, WeatherBox_weatherValue(state_1, v_1, weatherPoint, (value_11) => singleton_1(["style", createObj(Style_directionIcon(iconMargin, value_11))])));
                            }
                            case 3: {
                                const v_2 = _arg_5.fields[0];
                                const rowItem = ViewHelpers_mkRow(singleton_1(WeatherBox_mapBox(columnWidth_1, 28, toString(sensor), v_2.Location, 14)));
                                return WeatherBox_contentSublabel(empty(), v_2.Label, v_2.SubLabel, WeatherBox_mapBoxMaximizeIcon(() => {
                                    dispatch(new Msg(7, [new MainView(3, [new MapCenterAndZoom(v_2.Location, 14)])]));
                                }), rowItem);
                            }
                            case 2: {
                                const v_3 = _arg_5.fields[0];
                                const rowItem_1 = ViewHelpers_mkRow(singleton_1(WeatherBox_trendChart(columnWidth_1, 28, viewPort, ctx, state_1, viewConfig.TrendChartValuesFilter)));
                                return WeatherBox_content(ofArray([["onClick", (_arg_7) => {
                                    v_3.OnClick();
                                }], ["style", {
                                    cursor: "pointer",
                                }]]), v_3.Label, rowItem_1);
                            }
                            case 4: {
                                const v_4 = _arg_5.fields[0];
                                return WeatherBox_content(empty(), v_4.Label, ViewHelpers_mkRow(singleton_1(WeatherBox_rotatingDirectionSvg(columnWidth_1, 28, v_4))));
                            }
                            default: {
                                const v = _arg_5.fields[0];
                                return WeatherBox_content(empty(), v.Label, WeatherBox_weatherValue(state_1, v, weatherPoint, (_arg_6) => singleton_1(["style", createObj(toList(delay(() => iconMargin)))])));
                            }
                        }
                    });
                    return ViewHelpers_divWith([["style", createObj(Style_weatherBoxContainer(0.5))]], toList(delay(() => append(singleton(ViewHelpers_mkColumnWith([["width", columnWidth_1 + "vw"]], singleton_1(ViewHelpers_mkRowWith([["height", 28 + "vh"]], singleton_1(innerContent(tupledArg_3[0])))))), delay(() => {
                        const matchValue_6 = tupledArg_3[2];
                        if (matchValue_6 == null) {
                            return singleton(defaultOf_1());
                        }
                        else {
                            const label_3 = matchValue_6;
                            return singleton(ViewHelpers_spanWith([["style", createObj(Style_sensorLabel)]], singleton_1(label_3)));
                        }
                    })))));
                }, arg_1)), chunkBySize(columns_1, filter((tupledArg_2) => viewConfig.WeatherBoxFilter(tupledArg_2[0]), toList(delay(() => {
                    let sensor_2, latestWeatherBySensor;
                    const avgRange = bind((_arg_8) => _arg_8.WindSpeedAverageRange, weather);
                    return append((sensor != null) ? (!equals(sensor.GroupChildrens, empty()) ? ((sensor_2 = sensor, (latestWeatherBySensor = ofList(choose((tupledArg) => map_1((w_2) => [tupledArg[0], w_2], PortWindWeatherModule_mergeLatest(tupledArg[1])), toList_1(ofList(List_groupBy((w_1) => w_1.SensorId, state_1.WeatherHistory, {
                        Equals: equals,
                        GetHashCode: (x_5) => (safeHash(x_5) | 0),
                    }), {
                        Compare: (x_6, y_1) => (compare(x_6, y_1) | 0),
                    }))), {
                        Compare: (x_7, y_2) => (compare(x_7, y_2) | 0),
                    }), collect((childSensorId) => {
                        const matchValue_7 = tryFind_1(childSensorId, latestWeatherBySensor);
                        if (matchValue_7 != null) {
                            const childWeather = matchValue_7;
                            const childSensorName = getSensorName(childSensorId);
                            return choose((d) => map_1((_arg_9) => [boxFromDefinition(d), childWeather, childSensorName], d.GetValue(state_1, childWeather)), WeatherValue_values(state_1));
                        }
                        else {
                            return empty();
                        }
                    }, sensor_2.GroupChildrens)))) : choose((d_1) => map_1((_arg_10) => [boxFromDefinition(d_1), w, undefined], d_1.GetValue(state_1, w)), WeatherValue_values(state_1))) : choose((d_1) => map_1((_arg_10) => [boxFromDefinition(d_1), w, undefined], d_1.GetValue(state_1, w)), WeatherValue_values(state_1)), delay(() => append(defaultArg(map2((d_2, quays) => map((q) => [quayWeatherValue(d_2, q), w, undefined], quays), tryHead(choose_1((_arg_11) => _arg_11.WindDirection, state_1.WeatherHistory)), map_1((s_1) => s_1.Quays, sensor)), empty()), delay(() => append(!isEmpty(state_1.WeatherHistory) ? singleton([new WeatherValue_WeatherBox(2, [{
                        Label: "Trend",
                        OnClick: () => {
                            dispatch(new Msg(7, [new MainView(1, [])]));
                        },
                    }]), w, undefined]) : empty_1(), delay(() => map((tupledArg_1) => [new WeatherValue_WeatherBox(3, [{
                        Label: concat("Position - ", ...tupledArg_1[0]),
                        Location: tupledArg_1[1],
                        SubLabel: defaultArg(bind((s_3) => map_1((e_4) => (` (height: ${e_4}m)`), s_3.Elevation), sensor), ""),
                    }]), w, undefined], defaultArg(map_1((l_1) => cons(l_1, collect((_arg_12) => _arg_12.LocationsExtra, ofArray(toArray(sensor)))), map_1((l) => ["Wind", l], orElse(bind((w_3) => w_3.Location, weather), bind((s_2) => s_2.Location, sensor)))), empty()))))))));
                })))));
                return ViewHelpers_divWith([["style", {
                    marginTop: 0.5 + "vmax",
                }]], x_9);
            }
        }
    };
    return ViewHelpers_divWith([["data-portwind-dashboard", "true"], ["style", createObj(Style_dashboardRoot)]], toList(delay(() => {
        let matchValue_10;
        return append((matchValue_10 = weather, (matchValue_10 != null) ? (matchValue_10.IsFallbackData ? singleton(ViewHelpers_fallbackDataBanner("PortWind database is unavailable - showing cached measurements.")) : singleton(defaultOf_1())) : singleton(defaultOf_1())), delay(() => {
            let matchValue_11, w_6, weather_1, lastUpdated_2;
            return append((matchValue_11 = weather, (matchValue_11 != null) ? ((matchValue_11.Weather != null) ? ((w_6 = matchValue_11.Weather, (weather_1 = matchValue_11, append(singleton(header(viewConfig.HeaderConfig, weather_1.LastUpdated)), delay(() => singleton(content(w_6))))))) : ((lastUpdated_2 = matchValue_11.LastUpdated, append(singleton(header(viewConfig.HeaderConfig, lastUpdated_2)), delay(() => append(singleton(ViewHelpers_mkText(theme(new Color(0, [])), 10, [], "No data available!")), delay(() => singleton(defaultArg(map_1((sensorId_3) => content(PortWindWeather_Default(lastUpdated_2, sensorId_3)), state_1.SelectedSensor), HtmlHelper_createElement("div", empty())))))))))) : singleton(createElement("h3", defaultOf_2(), "Loading..."))), delay(() => singleton(createElement(thresholdModalView, {
                isOpen: patternInput_2[0],
                onClose: () => {
                    setThresholdModalOpen(false);
                },
                onSave: (arg_2) => {
                    dispatch(new Msg(18, [arg_2]));
                },
                state: state_1,
            }))));
        }));
    })));
}

